<template>
<div>
    <v-row>
        <v-col cols="12" md="3">
            <v-btn
                rounded
                block
                color="success"
                depressed
                @click="customerActivityShown = true">
                <v-icon>mdi-plus-circle</v-icon>
                <span class="ms-2">{{ $t("add_activity") }}</span>
            </v-btn>
        </v-col>
        <v-col cols="12" md="9">
            <v-row
                no-gutters
                class="mb-2"
                align="center">
                <v-col cols="6" md="6">
                    <div class="text-h6">
                        <span>Activities</span>
                        <v-btn
                            class="ms-1" 
                            small 
                            icon 
                            @click="fetchCustomerActivities" 
                            :loading="loading.data">
                            <v-icon>mdi-refresh</v-icon>
                        </v-btn>
                    </div>
                </v-col>
                <v-col
                    cols="6"
                    md="6"
                    class="d-flex justify-end">
                    <v-chip-group v-model="state" active-class="primary--text">
                        <v-chip
                            filter
                            outlined
                            value="OPEN">
                            Open
                            <v-badge
                                v-if="count.open > 0 && !loading.data"
                                :content="count.open" 
                                inline 
                                class="me-n2 ms-1" 
                                dark
                                color="grey"
                                >
                            </v-badge>
                        </v-chip>
                        <v-chip
                            filter
                            outlined
                            value="CLOSED">
                            Closed
                            <v-badge 
                                v-if="count.closed > 0 && !loading.data"
                                :content="count.closed" 
                                inline 
                                class="me-n2 ms-1" 
                                dark
                                color="grey">
                            </v-badge>
                        </v-chip>
                    </v-chip-group>
                </v-col>
            </v-row>
            <v-card outlined>
                <v-responsive
                    v-if="customerActivities.length && !loading.data"
                    max-height="300"
                    class="overflow-y-auto">
                    <v-list>
                        <customer-activity-item
                            v-for="(activity, index) in customerActivities"
                            :key="activity.id"
                            :activity="activity"
                            :last-item="index + 1 === customerActivities.length"
                            @click="handleActivityItemClick(activity)">
                        </customer-activity-item>
                    </v-list>
                </v-responsive>
                <div v-else-if="loading.data" class="text-center ma-2">
                    <!-- <v-progress-circular
                        indeterminate
                        color="primary"
                        class="ma-5">
                    </v-progress-circular> -->
                    <div class="text-body-1">Loading Customer Activities ...</div>
                </div>
                <div v-else class="text-body-1 text-center pa-2 grey--text">
                    {{ "No Activities!" }}
                </div>
            </v-card>
        </v-col>
    </v-row>
    <customer-activity-edit
        v-if="customerActivityShown"
        v-model="customerActivityShown"
        :customer="customer"
        @created="handleCreated">
    </customer-activity-edit>
    <customer-activity-display
        v-if="customerActivityDisplayShown"
        v-model="customerActivityDisplayShown"
        :activity="selectedActivity"
        :customer="customer"
        @updated="fetchCustomerActivities">
    </customer-activity-display>
</div>
</template>

<script>
import { isEmpty } from 'lodash';

import { getCustomerActivities } from '../../services/sales/customerActivity'
import CustomerActivityDisplay from './CustomerActivityDisplay.vue'
import CustomerActivityEdit from './CustomerActivityEdit.vue'
import CustomerActivityItem from './CustomerActivityItem.vue'
export default {
    components: {
        CustomerActivityEdit,
        CustomerActivityItem,
        CustomerActivityDisplay
    },
    name: "CustomerActivity",
    data() {
        return {
            customerActivityShown: false,
            customerActivityDisplayShown: false,
            selectedActivity: null,
            customerActivities: [],
            loading: {
                data: false
            },
            count: {
                open: 0,
                closed: 0
            },
            state: "OPEN"
        }
    },
    props: {
        customer: {
            required: true,
            type: Object
        }
    },
    watch: {
        state: {
            handler() {
                if(isEmpty(this.state)) return this.customerActivities = [];
                this.fetchCustomerActivities();
            }
        }
    },
    methods: {
        fetchCustomerActivities() {
            this.loading.data = true;
            getCustomerActivities({
                customer_id: this.customer.id,
                state: this.state
            }).then(response => {
                this.customerActivities = response.data.data;
                this.count.open = response.data.count.open;
                this.count.closed = response.data.count.closed;
            }).finally(() => {
                this.loading.data = false;
            })
        },
        handleActivityItemClick(activity) {
            this.selectedActivity = activity;
            this.customerActivityDisplayShown = true;
        },
        handleCreated(activity) {
            if(this.state !== "OPEN") return;
            this.customerActivities.unshift(activity);
            this.count.open = this.customerActivities.length;
        }
    },
    created() {
        this.fetchCustomerActivities();
    }
}
</script>
